/**
 * English (US) Localization
 *
 * This file contains all user-facing text strings for the application.
 * Structure is organized by feature/component for easy maintenance.
 *
 * Usage:
 * import { TOAST_MESSAGES } from 'locales/en-US';
 * toast.success(TOAST_MESSAGES.location.enabled);
 *
 * For dynamic content, use template functions:
 * toast.success(TOAST_MESSAGES.favorites.added(teamName));
 */

export const TOAST_MESSAGES = {
  // Location-related messages
  location: {
    enabled: 'Location enabled!',
    enableInSettings: 'Please enable location in your browser settings',
    servicesDisabled:
      'Location services disabled. Enable in browser settings to get directions.',
    notSupported: 'Geolocation is not supported by your browser',
    requestTimeout: 'Location request timed out. Please try again.',
    notAvailable: 'Location services are not available for this site.',
    infoUnavailable:
      'An error occurred. Location info for selected game is currently unavailable. Please try again later.',
  },

  // Favorites-related messages
  favorites: {
    added: (teamName) => `${teamName} added to your favorites list.`,
    removed: (teamName) => `${teamName} removed from your favorites list.`,
    addError: (teamName) =>
      `An error occurred while adding ${teamName} to your favorites list. Please try again later.`,
    removeError: (teamName) =>
      `An error occurred while removing ${teamName} from your favorites list. Please try again later.`,
  },

  // Authentication-related messages
  auth: {
    loginError:
      'An error occurred during login. Please use another login method or try again later.',
    loginErrorShort:
      'An error occurred during login. Please use another login method.',
    registrationSuccess:
      'Your registration was successful. You can sign in now.',
    passwordResetSent: (email) =>
      `Recovery password instructions were sent to ${email}`,
    passwordResetError:
      'An error occurred while restoring your password. Please make sure that you entered correct email or try again later.',
    passwordSaveSuccess: 'New password successfully saved. You can sign in now',
    passwordSaveError:
      'An error occurred while saving new password. Please make sure you entered the correct registration email or try again later.',
  },

  // Events-related messages
  events: {
    loadError:
      'An error occurred while loading events list. Please try again later.',
    loadSelectedError:
      'An error occurred while loading selected event list. Please try again later.',
  },

  // Generic error messages
  generic: {
    error: 'An error occurred. Please try again later.',
  },
};

// Export individual sections for convenience
export const LOCATION_MESSAGES = TOAST_MESSAGES.location;
export const FAVORITES_MESSAGES = TOAST_MESSAGES.favorites;
export const AUTH_MESSAGES = TOAST_MESSAGES.auth;
export const EVENTS_MESSAGES = TOAST_MESSAGES.events;
